<template>
  <template v-if="label">
    <div v-if="isCompleted" class="checkoutLightStep" :class="{ completed: isCompleted }">
      <img src="@/assets/img/icon-checked-circle.svg" alt="Passo concluído" />
      <small class="checkoutLightStep__label">{{ label }}</small>
    </div>

    <div v-else class="checkoutLightStep" :class="{ active: isActive }">
      <div class="checkoutLightStep__signal">
        <div class="checkoutLightStep__signal-circle1" />
        <div class="checkoutLightStep__signal-circle2" />
        <div class="checkoutLightStep__signal-circle3" />
      </div>
      <small class="checkoutLightStep__label">{{ label }}</small>
    </div>
  </template>
</template>

<script>
export default {
  name: 'CheckoutLightStep',
  props: {
    label: { type: String, required: true },
    isActive: { type: Boolean, default: false },
    isCompleted: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.checkoutLightStep {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__signal {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.4;
    position: relative;

    & div {
      background-color: $dark-400;
      border-radius: 50%;
      position: absolute;
    }

    &-circle1 {
      width: 10.67px;
      height: 10.67px;
      opacity: 0.7;
    }

    &-circle2 {
      width: 17.33px;
      height: 17.33px;
      opacity: 0.3;
    }

    &-circle3 {
      width: 24px;
      height: 24px;
      opacity: 0.2;
    }
  }

  &__label {
    margin-top: 16px;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 100%;
    text-align: center;
    letter-spacing: -0.01em;
    color: $dark-300;
  }
}

.checkoutLightStep.active {
  .checkoutLightStep__signal {
    opacity: 1;

    & div {
      background-color: $seer-stone;
    }
  }

  .checkoutLightStep__label {
    font-weight: 700;
    color: $seer-stone;
  }
}

.checkoutLightStep.completed {
  margin-top: -12px;

  .checkoutLightStep__label {
    margin-top: 2px;
    color: $seer-stone;
  }
}
</style>
